import { render, staticRenderFns } from "./ArticleCategory.vue?vue&type=template&id=4222f8f8&scoped=true"
import script from "./ArticleCategory.vue?vue&type=script&lang=js"
export * from "./ArticleCategory.vue?vue&type=script&lang=js"
import style0 from "./ArticleCategory.vue?vue&type=style&index=0&id=4222f8f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4222f8f8",
  null
  
)

export default component.exports